import React from 'react'
import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import DatePicker from 'react-toolbox/lib/date_picker'
import { IconButton } from 'react-toolbox/lib/button'
import { convertUTCDateToLocalDate, getMonthDateYearString } from 'helpers/DateUtil'

import theme from './DatePickerIconButton.scss'

class DatePickerIconButton extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      active: false
    }
  }

  toggleActiveDatePicker(){
    this.setState({
      active: !this.state.active
    })
  }

  render() {
    let {
      label,
      onChange,
      value,
      disabled
    } = this.props

    return (
      <span class={theme.iconWrapper}>
        <IconButton primary theme={theme} disabled={disabled} icon='today' onClick={()=> this.toggleActiveDatePicker()}/>
        <div style={{display: 'none'}}>
          <DatePicker
            minDate={new Date('January 1, 2018')}
            active={this.state.active}
            onDismiss={() => this.toggleActiveDatePicker()}
            label={label}
            onChange={(date) => {
              onChange(date)
              this.toggleActiveDatePicker()
            }}
            value={value}
            sundayFirstDayOfWeek
          />
        </div>
      </span>
    )
  }
}

export default CSSModules(DatePickerIconButton, theme)
